<template>
  <!-- <basic-container > -->
  <div class="card-container" style="background: #f0f2f5">
    <div class="card-row">
      <div class="card card-20">
        <div
          ref="deviceWearChart"
          class="device-wear-chart"
          role="img"
          aria-label="设备佩戴率趋势图，展示最近14天的示例数据，纵轴为佩戴率百分比"
        ></div>
      </div>
      <div class="card card-50" style="position: relative">
        <el-button-group class="chart-buttons">
          <el-button
            :type="isSelected === 1 ? 'success' : 'default'"
            @click="isSelected = 1"
            >日</el-button
          >
          <el-button
            :type="isSelected === 2 ? 'success' : 'default'"
            @click="isSelected = 2"
            >月</el-button
          >
          <el-button
            :type="isSelected === 3 ? 'success' : 'default'"
            @click="isSelected = 3"
            >年</el-button
          >
          <el-date-picker
            v-model="date1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="margin-left: 1vw"
          >
          </el-date-picker>
        </el-button-group>
        <div id="columnChart1" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
      <div class="card card-20">
        <div id="pieChart1" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
    </div>
    <div class="card-row">
      <div class="card card-20">
        <div id="columnChart2" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
      <div class="card card-20">
        <div id="pieChart2" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
      <div class="card card-50" style="position: relative">
        <div id="lineChart1" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
    </div>
  </div>
  <!-- </basic-container> -->
</template>

<script>
export default {
  name: "ThreeCardLayout",
  data() {
    return {
      isSelected: 1,
      // 暂用示例佩戴率；接入接口后替换为实际日期及对应百分比。
      deviceWearData: Array.from(
        [72, 75, 73, 79, 82, 80, 84, 86, 83, 88, 90, 87, 91, 93],
        (rate, index) => {
          const date = new Date();
          date.setDate(date.getDate() - 13 + index);
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return { date: `${date.getFullYear()}-${month}-${day}`, rate };
        }
      ),
      list: [
        { b: 0, c: 0 },
        { b: 0, c: 3 },
        { b: 0, c: 4 },
        { b: 0, c: 6 },
        { b: 0, c: 10 },
        { b: 0, c: 0 },
        { b: 0, c: 0 },
        { b: 4, c: 35 },
        { b: 19, c: 43 },
        { b: 9, c: 32 },
        { b: 19, c: 20 },
        { b: 15, c: 17 },
        { b: 0, c: 0 },
        { b: 0, c: 0 },
        { b: 18, c: 12 },
        { b: 7, c: 15 },
        { b: 8, c: 2 },
        { b: 4, c: 5 },
      ],
      date1: [],
    };
  },
  created() {},
  mounted() {
    this.initDeviceWearChart();
    this.columnChart1();
    this.pieChart1();
    this.columnChart2();
    this.lineChart1();
    this.pieChart2();
  },
  activated() {
    this.$nextTick(this.resizeDeviceWearChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeDeviceWearChart);
    if (this._deviceWearObserver) {
      this._deviceWearObserver.disconnect();
    }
    if (this._deviceWearChart) {
      this._deviceWearChart.dispose();
      this._deviceWearChart = null;
    }
  },
  methods: {
    resizeDeviceWearChart() {
      if (this._deviceWearChart) {
        this._deviceWearChart.resize();
      }
    },
    initDeviceWearChart() {
      const chart = this.$echarts.init(this.$refs.deviceWearChart);
      this._deviceWearChart = chart;
      chart.setOption({
        title: {
          text: "设备佩戴率",
          subtext: "最近14天 · 示例数据",
          left: "left",
          textStyle: { fontSize: 15 },
          subtextStyle: { color: "#909399", fontSize: 12 },
        },
        grid: { left: 12, right: 20, top: 80, bottom: 40, containLabel: true },
        tooltip: {
          trigger: "axis",
          confine: true,
          formatter: "{b}<br/>{a}：{c}%",
          axisPointer: { type: "line", lineStyle: { color: "#a8bbde" } },
        },
        xAxis: {
          type: "category",
          name: "日期",
          nameLocation: "middle",
          nameGap: 28,
          boundaryGap: false,
          data: this.deviceWearData.map((item) => item.date),
          axisLabel: {
            color: "#606266",
            formatter: (value) => value.slice(5),
            hideOverlap: true,
          },
          axisLine: { lineStyle: { color: "#dcdfe6" } },
          axisTick: { show: false },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: { formatter: "{value}%", color: "#606266" },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: "#ebeef5", type: "dashed" } },
        },
        series: [
          {
            name: "设备佩戴率",
            type: "line",
            symbol: "circle",
            symbolSize: 6,
            data: this.deviceWearData.map((item) => item.rate),
            lineStyle: { width: 3, color: "#355CB0" },
            itemStyle: { color: "#355CB0", borderColor: "#fff", borderWidth: 1 },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(53, 92, 176, 0.25)" },
                { offset: 1, color: "rgba(53, 92, 176, 0.02)" },
              ]),
            },
          },
        ],
      });
      window.addEventListener("resize", this.resizeDeviceWearChart);
      if (typeof ResizeObserver !== "undefined") {
        this._deviceWearObserver = new ResizeObserver(this.resizeDeviceWearChart);
        this._deviceWearObserver.observe(this.$refs.deviceWearChart);
      }
    },
    columnChart1() {
      // 获取本月天数并生成日期数组
      const now = new Date();
      const daysInMonth = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        0
      ).getDate();
      console.log(daysInMonth);
      const monthDays = Array.from(
        { length: daysInMonth + 1 },
        (_, i) => `${i < 10 && i !== 0 ? "0" + i : i === 0 ? "" : i}`
      );

      // 准备数据
      const test = this.list.map((v) => v.b);
      const motion = this.list.map((v) => v.c);

      const myChart = this.$echarts.init(
        document.getElementById("columnChart1")
      );
      // 绘制图表
      myChart.setOption({
        title: {
          // text: "测试人数&运动人数",
          text: "重疾中风险人数&重疾高风险人数",
          left: "left",
          textStyle: {
            fontSize: 15,
            // fontWeight: "bold",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // data: ["测试人数", "运动人数"],
          data: ["重疾中风险人数", "重疾高风险人数"],
          left: "right",
          top: 30,
          itemWidth: 25,
          itemHeight: 14,
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: monthDays,
          axisLabel: {
            // 修改x轴标签
            interval: 0,
            rotate: 0,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: function (value) {
            return Math.max(Math.floor(value.max / 10) * 10 + 10); // 取最大值 +10
          },
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "测试人数",
            type: "bar",
            data: test,
          },
          {
            name: "运动人数",
            type: "bar",
            data: motion,
          },
        ],
        color: ["#355CB0", "#E4B858"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    pieChart1() {
      const myChart = this.$echarts.init(document.getElementById("pieChart1"));
      const data = [
        { value: 68, name: "非药物" },
        { value: 32, name: "药物" },
      ];

      const option = {
        title: {
          text: "药物治疗和非药物占比",
          // subtext: "数据统计",
          left: "left",
          top: "top",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          top: "top",
          left: "right",
          data: ["非药物", "药物"],
        },
        series: [
          {
            name: "比例",
            type: "pie",
            radius: ["30%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "bottom",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "18",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
            color: ["#5470c6", "#ee6666"],
            // 圆角效果
            roundCap: true,
          },
        ],
        animation: true,
        animationDuration: 1000,
        animationEasing: "cubicInOut",
      };

      myChart.setOption(option);

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    columnChart2() {
      const myChart = this.$echarts.init(
        document.getElementById("columnChart2")
      );
      // 绘制图表
      myChart.setOption({
        title: {
          // text: "力量&有氧处方等级分布",
          text: "力量&有氧处方等级分布",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: "shadow",
          // },
        },
        legend: {
          data: ["力量处方", "有氧处方"],
          left: "center",
          bottom: "bottom",
          itemWidth: 25,
          itemHeight: 14,
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "value",
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true,
          },
          min: 0,
          max: function (value) {
            return Math.max(Math.floor(value.max / 10) * 10 + 10);
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        yAxis: {
          type: "category",
          data: ["", "差", "偏差", "中等", "良好", "优秀", ""],
          boundaryGap: false,
          axisLabel: {
            interval: 0,
            rotate: 0,
            margin: 7,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        series: [
          {
            name: "力量处方",
            type: "bar",
            data: [0, 20, 32, 83, 114, 55],
          },
          {
            name: "有氧处方",
            type: "bar",
            data: [0, 10, 42, 73, 100, 45],
          },
        ],
        color: ["#345ABB", "#78B64A"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    lineChart1() {
      const myChart = this.$echarts.init(document.getElementById("lineChart1"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "体型人数分布",
          left: "left",
          textStyle: {
            fontSize: 15,
            // fontWeight: "bold",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "",
            "低脂地体重",
            "低脂肌肉型",
            "运动员型",
            "低体重",
            "标准体型",
            "超重肌肉型",
            "隐形肥胖",
            "脂肪过载",
            "肥胖",
          ],
          axisLabel: {
            // 修改x轴标签
            interval: 0,
            rotate: 0,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: function (value) {
            return Math.max(Math.floor(value.max / 10) * 10 + 10); // 取最大值 +10
          },
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "测试人数",
            type: "line",
            data: [0, 3, 4, 0, 1, 25, 11, 0, 3, 16],
            stack: "总量",
            areaStyle: {},
          },
        ],
        color: ["#355CB0"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    pieChart2() {
      const myChart = this.$echarts.init(document.getElementById("pieChart2"));
      const data = [
        { value: 2, name: "20岁以下" },
        { value: 25, name: "20-29岁" },
        { value: 128, name: "30-39岁" },
        { value: 152, name: "40-49岁" },
        { value: 168, name: "50-59岁" },
        { value: 72, name: "60-69岁" },
        { value: 12, name: "70-79岁" },
        { value: 3, name: "80岁以上" },
      ];

      const option = {
        title: {
          text: "年龄分布",
          left: "left",
          top: "top",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        // legend: {
        //   orient: "vertical",
        //   top: "top",
        //   left: "right",
        //   data: ["20岁以下", "20-29岁", "30-39岁", "40-49岁", "60-69岁", "", ""],
        // },
        series: [
          {
            name: "年龄分布",
            type: "pie",
            radius: "65%",
            avoidLabelOverlap: true,
            center: ["50%", "50%"],
            itemStyle: {
              borderRadius: 4,
              borderColor: "#fff",
              borderWidth: 0,
            },
            label: {
              show: true,
              position: "right",
              color: "black",
              fontSize: 12,
              // verticalAlign: "middle",
              // distanceToLabelLine: 0,
              // padding: [5, 10],
              // backgroundColor: "rgba(255,255,255,0.8)",
              // borderColor: "#eee",
              // borderWidth: 1,
              // borderRadius: 4,
            },
            labelLine: {
              length: 15, // 第一段线长度
              length2: 10, // 第二段线长度
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            data: data,
            color: [
              "#355ABC",
              "#7BB05C",
              "#EAB83E",
              "#D74E52",
              "#55B9D9",
              "#21915D",
              "#EC7546",
              "#8A589D",
            ],
            // 圆角效果
            roundCap: true,
          },
        ],
        animation: true,
        animationDuration: 1000,
        animationEasing: "cubicInOut",
      };

      myChart.setOption(option);

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>

<style scoped>
.device-wear-chart {
  width: 100%;
  height: 40vh;
}

.card-container {
  width: 100%;
  max-width: 100vw; /* 可根据需要调整最大宽度 */
  margin: 0 auto;
  padding: 1vw;
  box-sizing: border-box;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vw;
  gap: 1vw;
}

.card {
  background: #fff;
  /* border-radius: 8px; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card-50 {
  flex: 1 1 calc(40% - 1vw); /* 50%宽度减去gap */
  height: 43vh;
}

.card-20 {
  flex: 1 1 calc(20% - 1vw); /* 20%宽度减去gap */
  height: 43vh;
}

.chart-buttons {
  position: absolute;
  top: 0.5vw; /* 距离顶部距离 */
  right: 1vw; /* 距离右侧距离 */
  z-index: 100; /* 确保按钮在图表上方 */
  opacity: 0.9; /* 可选：轻微透明效果 */
  width: auto;
}

.card-header {
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-total {
  font-size: 24px;
  font-weight: 600;
  margin-top: 8px;
}
</style>
